import Slider from 'components/slider';
import Tabs from 'components/tabs';

/**
 * Табы в блоке как купить.
 * @type {Element}
 */
const tabsPurchaseClass = document.querySelector('.j-tabs-purchase');

if (tabsPurchaseClass) {
    const tabsPurchase = new Tabs();

    tabsPurchase.init({
        element             : '.j-tabs-purchase',
        tabsItemClass       : '.purchase-tabs__button',
        tabsContentItemClass: '.purchase-tabs__content-item'
    });
}

const purchaseSliderWrap = document.querySelector('.j-slider-purchase');

if (purchaseSliderWrap) {
    const sliderPurchase = new Slider();

    sliderPurchase.init({
        slider       : purchaseSliderWrap,
        dots         : false,
        thumbnails   : false,
        arrow        : true,
        counter      : true,
        arrowPosition: 'caption',
        modify       : 'purchase_slide',
        slideVisible : 3,
        responsive   : {
            0   : 1.15,
            670 : 1.5,
            960 : 2,
            1280: 3
        }
    });
}
